export default "__VITE_PUBLIC_ASSET__163aa1d0__"